export default "__VITE_ASSET__DlUhOP6B__"